/**
 * Day0提出の一覧（講師サイト・マネージャーサイト）の表示。
 * 10秒・伸びしろ診断（LINEの音声メッセージ）は、呼び名を聞かないので名前の欄は LINE の表示名にし、
 * 「10秒診断」の印と音声の長さを出す。これまでの約1分のミニ体験は今までどおり。
 */

export const VOICE_VARIANT = 'line_voice_10s'

export const isVoiceDay0Submission = (d) => d?.variant === VOICE_VARIANT

/** 名前の欄（ひらがなの呼び名。無ければ LINE の表示名。10秒診断は呼び名を聞かないので LINE 名になる） */
export function day0NameLabel(d) {
  const name = (d?.nameHiragana || '').trim()
  if (name) return name
  const lineName = (d?.lineDisplayName || '').trim()
  return lineName ? `${lineName}（LINE）` : '—'
}

/** 体験の種類の印（これまでの体験は空） */
export function day0KindLabel(d) {
  return isVoiceDay0Submission(d) ? '10秒診断' : ''
}

/** 音声の長さ（秒）。無ければ空 */
export function day0DurationLabel(d) {
  const sec = Number(d?.durationSeconds)
  if (!Number.isFinite(sec) || sec <= 0) return ''
  return `${Math.round(sec * 10) / 10}秒`
}

/** フィードバック録音の画面の見出し */
export function day0FeedbackTitle(d) {
  const name = (d?.nameHiragana || '').trim()
  if (name) return `${name}さんへのフィードバック`
  const lineName = (d?.lineDisplayName || '').trim()
  if (lineName) return `${lineName}（LINE）さんへのフィードバック`
  return isVoiceDay0Submission(d) ? '10秒診断へのフィードバック' : 'フィードバック'
}
